import React, {useState, useRef, useEffect} from 'react'
import './Paypal.css'

function Paypal({product, paidFor, setPaidFor}) {
    const [error, setError] = useState(null);
    const paypalRef = useRef();
    useEffect(() => {
        if (product.finishedRender) {
        window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                    description: "Bought from Itay's Restaurant",
                    amount: {
                        currency_code: 'EUR',
                        value: product.price,
                    },
                    },
                ],
                });
            },
            onApprove: async (data, actions) => {
                const order = await actions.order.capture();
                setPaidFor(true);
                product.captureID = order.purchase_units[0].payments.captures[0].id;
            },
            onError: err => {
                setError(err);
                console.error(err);
            },
            })
            .render(paypalRef.current);
        }
    }, [product.price]);

    if (paidFor) {
      // If the page is on English
      if (window.location.href.includes('/en')) { 
        return (
          <div style={{fontSize: '25px'}}>
            <span style={{display: 'inline-block'}}>Congrats, you just bought {product.name}!</span>
            <span style={{display: 'block'}}>{product.extras}</span>
          </div>
        )
      }
      // Else render it in Hebrew
        return (
          <div style={{fontSize: '25px'}}>
            <span style={{display: 'inline-block'}}>ברכותיי, הרגע רכשת {product.name}!</span>
            <span style={{display: 'block'}}>{product.extras}</span>
          </div>
        );
      }
    else {
      return (          
        <div>
        {product.finishedRender &&
            <React.Fragment>
          {error && <div>Uh oh, an error occurred! {error.message}</div>}
          <div ref={paypalRef} style={{maxWidth: '750px', margin: '0 auto'}} />
          </React.Fragment>
        }
        </div>
      );
    }

}

export default React.memo(Paypal)
